/**
 * Universal Currency & Number Formatters for Indonesian ERP
 */

/**
 * Format numbers to standard Indonesian Rupiah (e.g., Rp 55.500 or Rp 1.250.000)
 * Uses standard thousand dots and zero decimal places for round numbers.
 */
export function formatRupiah(amount: number | string | null | undefined): string {
  if (amount === null || amount === undefined || amount === '') return 'Rp 0';
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return 'Rp 0';

  const rounded = Math.round(num);
  return `Rp ${rounded.toLocaleString('id-ID')}`;
}

/**
 * Ant Design InputNumber Formatter for Rupiah
 * Automatically inserts 'Rp ' and dot separators as the user types
 */
export const rupiahInputFormatter = (val: number | string | undefined): string => {
  if (val === undefined || val === null || val === '') return '';
  const str = String(val);
  const parts = str.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `Rp ${parts.join(',')}`;
};

/**
 * Ant Design InputNumber Parser for Rupiah
 * Extracts raw number string from formatted Rupiah text
 */
export const rupiahInputParser = (val: string | undefined): number => {
  if (!val) return 0;
  const cleaned = val.replace(/Rp\s?|(\.*)/g, '').replace(/,/g, '.');
  return Number(cleaned) || 0;
};
